import { toast } from "react-toastify";
import { API_COMERCIALES } from "../views/MainLayout/components/shared/services/comerciales";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialComerciales = {
    detalle: []
};

export const comercialDetailReducer = (state = initialComerciales, action) => {
    switch(action.type){
        case "comercial_detail/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchDetallesEntidades = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_COMERCIALES.getDetallesEntidades(page, search)
        const data = await response.data;

        if(search?.includes('search') && !search?.includes('seccion')) {
            const activeSection = data?.secciones.reduce((prev, current) => (prev.total_items > current.total_items) ? prev : current)
        
            if(activeSection) {
                localStorage.setItem('comerciales-tab', activeSection.item);
            }
        }

        dispatch({ type: 'comercial_detail/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}